import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import isEqual from 'lodash/isEqual'
import { Container, Draggable } from 'react-smooth-dnd'
import uniqid from 'uniqid';
import { dispatch } from '@rematch/core';
import Loader from './Loader'
import Card from './Card'
import NewCard from './NewCard'
import { AddCardLink, LaneFooter, ScrollableLane, Section } from '../../styles/Base'
import { Icon } from "semantic-ui-react";
import { toastr } from 'react-redux-toastr';
import * as laneActions from '../actions/LaneActions'
import { CollapseBtn, ExpandBtn } from '../../styles/Elements'

import PlaybookActivityCard from '../../../cards/PlaybookActivityCard'
class Lane extends Component {
  state = {
    loading: false,
    currentPage: this.props.currentPage,
    addCardMode: false,
    collapsed: false,
    isDraggingOver: false
  }

  handleScroll = evt => {
    const node = evt.target
    const elemScrolPosition = node.scrollHeight - node.scrollTop - node.clientHeight
    const { onLaneScroll } = this.props
    if (elemScrolPosition <= 0 && onLaneScroll && !this.state.loading) {
      const { currentPage } = this.state
      this.setState({ loading: true })
      const nextPage = currentPage + 1
      onLaneScroll(nextPage, this.props.id).then(moreCards => {
        if (!moreCards || moreCards.length === 0) {
          // if no cards present, stop retrying until user action
          node.scrollTop = node.scrollTop - 100
        } else {
          this.props.actions.paginateLane({
            laneId: this.props.id,
            newCards: moreCards,
            nextPage: nextPage
          })
        }
        this.setState({ loading: false })
      })
    }
  }

  sortCards(cards, sortFunction) {
    if (!cards) return []
    if (!sortFunction) return cards
    return cards.concat().sort(function (card1, card2) {
      return sortFunction(card1, card2)
    })
  }

  laneDidMount = node => {
    if (node) {
      node.addEventListener('scroll', this.handleScroll)
    }
  }

  componentWillReceiveProps(nextProps) {
    if (!isEqual(this.props.cards, nextProps.cards)) {
      this.setState({
        currentPage: nextProps.currentPage
      })
    }
  }



  handleCardClick = async (e, card) => {
    await dispatch.lifeCycle.setIdToCenterPosition(card._id)
    const { onCardClick } = this.props
    onCardClick && onCardClick(card.id, card.metadata, card.laneId)
    dispatch.lifeCycle.showResourecePane("PracticeCommunitySwimLineCommanPane")
    dispatch.createPack.getSelectedActivityAsync(card._id);
    dispatch.createPack.setSelectedCommunityData({});

    dispatch.createPack.activityUniqueIdSet(card._id);
    // dispatch.lifeCycle.displaySecondMenu("Activities");

    if (this.props.collapsedResourcePaneIndexTemp === null) {
      dispatch.lifeCycle.splitAt("60%");
    }
    else {
      dispatch.app.setCollapsedResourcePaneIndexTemp(null)
    }
    e.stopPropagation()
    e.preventDefault()
  }

  doubleClickOnActivity = (e) => {
    dispatch.lifeCycle.showResourecePane("PracticeCommunitySwimLineCommanPane")
    dispatch.app.setCollapsedResourcePaneIndexTemp(null)
    dispatch.lifeCycle.splitAt("60%");


  };

  showEditableCard = () => {
    this.setState({ addCardMode: true })
    this.props.setCurrentLane(this.props.title, this.props.objectId);
  }

  hideEditableCard = () => {
    this.setState({ addCardMode: false })
  }

  addNewCard = params => {
    const laneId = this.props.id
    const id = uniqid()
    this.hideEditableCard()
    let card = { ...params, id }
    this.props.actions.addCard({ laneId, card })
    this.props.onCardAdd(card, laneId)

    const nodeToAdd = {
      name: params.title,
      description: params.description,
      packId: this.props.selectedPracticeLibrary._id,
      branchID: this.props.selectedPracticeLibrary.branches[0],
      lastUpdatedBy: this.props.user,
      parentCommunity: this.props._id
    }

    dispatch.lifeCycle.createCommunity(nodeToAdd)

  }

  renderAddCardLink = () => {
    const { addCardLink } = this.props
    if (addCardLink) {
      return <span onClick={this.showEditableCard}>{addCardLink}</span>
    } else {
      return <AddCardLink onClick={this.showEditableCard}>Add Card</AddCardLink>
    }
  }

  renderNewCard = () => {
    const { newCardTemplate, id } = this.props
    if (newCardTemplate) {
      const newCardWithProps = React.cloneElement(newCardTemplate, {
        onCancel: this.hideEditableCard,
        onAdd: this.addNewCard,
        laneId: id
      })
      return <span>{newCardWithProps}</span>
    } else {
      return <NewCard onCancel={this.hideEditableCard} onAdd={this.addNewCard} />
    }
  }

  onDragStart = ({ payload }) => {
    //dispatch.lifeCycle.showResourecePane(null);
    const { handleDragStart } = this.props
    handleDragStart && handleDragStart(payload.id, payload.laneId)
  }

  shouldAcceptDrop = sourceContainerOptions => {
    return this.props.droppable && sourceContainerOptions.groupName === 'TrelloLane'
  }

  removeCard = async (e, card) => {
    let message = <div className="confirmMessage">
      <h3>Delete Activity</h3>
      <label>{card.name}</label>
      <p>Are you sure that you wish to do this?</p>
      <span >This action is not reversible</span>
    </div>
    toastr.confirm(message, {
      onOk: async () => {
        // dispatch.app.setCollapsedResourcePaneIndexTemp(null)
        // dispatch.initiatives.showResourecePane(null);
        try {
          await dispatch.lifeCycle.deleteActivity({ packId: this.props.selectedPracticeLibrary._id, id: card._id });
          dispatch.app.setCollapsedResourcePaneIndexTemp(null)
          dispatch.lifeCycle.showResourecePane(null);
        }
        catch (err) {
          dispatch.lifeCycle.setError(err);
        }
      }
    });


  }

  onDragEnd = async (laneId, result) => {
    const { handleDragEnd, boardId } = this.props
    const { addedIndex, payload } = result;
    let targetLane;
    if (this.props.stages._id.toString() === laneId.toString()) {
      targetLane = this.props.stages;
    }
    let activity = this.props.selectedPracticeLibrary.sequenceViewMap.get(payload._id.toString())
    let isCardExist = targetLane && targetLane.cards && targetLane.cards.filter(card => { return card._id.toString() === payload._id.toString() }).length > 0
    if (!isCardExist || payload.laneId === laneId) {
      if (addedIndex != null) {
        let index = activity ? activity.raci.r.indexOf(payload.laneId) : payload.raci.r.indexOf(payload.laneId)
        if (index !== -1) {
          activity.raci.r.splice(index, 1, laneId)
          dispatch.createPack.updateActivityAction({
            r: payload.laneId,
            deleted: true
          });
          dispatch.createPack.updateActivityAction({
            r: laneId,
            index: addedIndex
          });
          dispatch.createPack.editActivityAsync(activity)
          dispatch.createPack.clearActivityActions();
          this.props.actions.moveCardAcrossLanes({
            fromBoardId: payload.boardId,
            fromLaneId: payload.laneId,
            toBoardId: boardId,
            toLaneId: laneId,
            cardId: payload._id,
            index: addedIndex,
            communityTagColor: payload.communityTagColor,
            duration: payload.duration
          })
          handleDragEnd && handleDragEnd(payload.id, payload.laneId, laneId, addedIndex, payload)
        }

      }
    }
    this.setState({ isDraggingOver: false })
  }

  renderDragContainer = isDraggingOver => {
    const {
      laneSortFunction,
      editable,
      hideCardDeleteIcon,
      tagStyle,
      cardStyle,
      draggable,
      cardDraggable,
      cards,
      cardDragClass

    } = this.props
    const { collapsed } = this.state

    const showableCards = collapsed ? [] : cards
    const cardList = this.sortCards(showableCards, laneSortFunction).map((card, idx) => {
      const cardToRender = (
        <Card
          id={card._id}
          key={card.id}
          cardDetail={card}
          index={idx}
          customCardLayout={this.props.customCardLayout}
          selectedPracticeLibrary={this.props.selectedPracticeLibrary}
          customCard={this.props.children}
          tagStyle={tagStyle}
          cardStyle={cardStyle}
          removeCard={e => this.removeCard(e, card)}
          onClick={e => this.handleCardClick(e, card)}
          onDoubleClick={this.doubleClickOnActivity}
          onDelete={this.props.onCardDelete}
          editable={editable}
          hideCardDeleteIcon={hideCardDeleteIcon}
          style={{ display: !card.isLeafNode ? 'none' : '' }}
          className={`  `}

          //  className={`
          // ${this.props.activityUniqueId == card._id ? "activeActivity cursor-auto" : "cursor-pointer"}  
          //  ${card.communityTagColor ? "border_left_4" : ""} 
          //${card.isMilestone ? "milestone-color" : ""} 
          //   `}

          communities={this.props.selectedPracticeLibrary.communities}
          selectedActivity={this.props.selectedPracticeFlowActivity}
          {...card}
          user={this.props.user}
          currentOrganization={this.props.currentOrganization}
        />
      )
      return draggable && cardDraggable ? (
        <Draggable key={card.id}>{cardToRender}</Draggable>
      ) : (
          <span key={card.id}>{cardToRender}</span>
        )
    })
    let height = this.props.componentDesignerDimension;
    let setHeight = (height.windowHeight - height.height) - 387;

    return (
      <ScrollableLane innerRef={this.laneDidMount} isDraggingOver={isDraggingOver}>
        <Container
          orientation="vertical"
          groupName="TrelloLane"
          dragClass={cardDragClass}
          onDragStart={this.onDragStart}
          onDrop={e => this.onDragEnd(this.props.objectId, e)}
          onDragEnter={() => this.setState({ isDraggingOver: true })}
          onDragLeave={() => this.setState({ isDraggingOver: false })}
          shouldAcceptDrop={this.shouldAcceptDrop}
          style={{ maxHeight: setHeight }}
          className="overflow-hide"
          getChildPayload={index => this.props.getCardDetails(this.props.objectId, index)}>
          {cardList}
        </Container>
      </ScrollableLane>
    )
  }

  handleLaneheaderClick = (e, stages) => {
    dispatch.lifeCycle.showResourecePane("CommunityFlow")
    dispatch.createPack.getSelectedCommunityAsync(stages._id);
    dispatch.createPack.activityUniqueIdSet(stages._id);
    dispatch.createPack.setSelectedActivity({})
    //dispatch.lifeCycle.setIdToCenterPosition("center-" + card._id)
    dispatch.app.setCollapsedResourcePaneIndexTemp(null)
    dispatch.lifeCycle.splitAt("60%");

  }

  renderHeader = () => {

    const { customLaneHeader, tagColor } = this.props;
    if (customLaneHeader) {
      const customLaneElement = React.cloneElement(customLaneHeader, { ...this.props })
      return <span>{customLaneElement}</span>
    } else {
      const { title, label, titleStyle, labelStyle, tagColor } = this.props
      return (
        <div title="">
          {/* <LaneHeader
            title=""
            onClick={e => this.handleLaneheaderClick(e, this.props.stages)}
            style={{ "cursor": "pointer", "borderLeft": "4px solid" + tagColor }}
            className={this.props.activityUniqueId == this.props.stages._id ? "activeActivity" : ""}
          >
            <Title style={titleStyle}  >
              <EllipsisTooltip name={title} line={2} /></Title>
          </LaneHeader> */}
          <div
            onClick={e => this.handleLaneheaderClick(e, this.props.stages)}
            style={{ "cursor": "pointer", 'width': "200px", 'margin': "3px", }}>
            <PlaybookActivityCard
              type="stage"
              page="assign"
              selectedPracticeLibrary={this.props.selectedPracticeLibrary}
              activityData={this.props}
              selectedActivity={this.props.selectedPracticeFlowCommunity}
              communities={this.props.selectedPracticeLibrary.communities}
              _id={this.props._id}
              user={this.props.user}
              currentOrganization={this.props.currentOrganization}
            />
          </div>


          <div className="activityCount" onClick={this.toggleLaneCollapsed}>
            <Icon name={this.state.collapsed ? "angle right" : "angle down"} className="vert_middle" /><span>{this.props.stages && this.props.stages.cards && this.props.stages.cards.filter(card => { return card.isLeafNode; }).length ? this.props.stages.cards.filter(card => { return card.isLeafNode; }).length : 0}</span> Activities
          </div>
        </div>
      )
    }
  }

  renderFooter = () => {
    const { collapsibleLanes, cards } = this.props
    const { collapsed } = this.state
    if (collapsibleLanes && cards.length > 0) {
      return <LaneFooter onClick={this.toggleLaneCollapsed}>{collapsed ? <ExpandBtn /> : <CollapseBtn />}</LaneFooter>
    }
  }

  toggleLaneCollapsed = () => {
    this.props.collapsibleLanes && this.setState(state => ({ collapsed: !state.collapsed }))
  }

  render() {
    const { loading, isDraggingOver } = this.state
    const { id, onLaneClick, ...otherProps } = this.props

    return (
      <Section title="" className={otherProps.isDummy ? 'no-stage-added' : null} {...otherProps} key={id} onClick={() => onLaneClick && onLaneClick(id)} draggable={false}>
        {this.renderHeader()}
        {this.renderDragContainer(isDraggingOver)}
        {loading && <Loader />}
        {this.renderFooter()}
      </Section>
    )
  }
}

Lane.propTypes = {
  actions: PropTypes.object,
  children: PropTypes.node,
  id: PropTypes.string.isRequired,
  title: PropTypes.node,
  index: PropTypes.number,
  laneSortFunction: PropTypes.func,
  style: PropTypes.object,
  cardStyle: PropTypes.object,
  tagStyle: PropTypes.object,
  titleStyle: PropTypes.object,
  labelStyle: PropTypes.object,
  customLaneHeader: PropTypes.element,
  customCardLayout: PropTypes.bool,
  cards: PropTypes.array,
  label: PropTypes.string,
  currentPage: PropTypes.number,
  draggable: PropTypes.bool,
  collapsibleLanes: PropTypes.bool,
  droppable: PropTypes.bool,
  onLaneScroll: PropTypes.func,
  onCardClick: PropTypes.func,
  onCardDelete: PropTypes.func,
  onCardAdd: PropTypes.func,
  onLaneClick: PropTypes.func,
  newCardTemplate: PropTypes.node,
  addCardLink: PropTypes.node,
  editable: PropTypes.bool,
  cardDraggable: PropTypes.bool,
  cardDragClass: PropTypes.string
}

Lane.defaultProps = {
  style: {},
  titleStyle: {},
  labelStyle: {},
  label: undefined,
  editable: false,
  onCardAdd: () => { }
}

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(laneActions, dispatch)
})

export default connect(null, mapDispatchToProps)(Lane)
